import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = 'md'
}: ModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-0" data-id="element-346">
      <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-347" />

      <div className={`relative bg-white rounded-xl shadow-2xl w-full ${maxWidthClasses[maxWidth]} overflow-hidden transform transition-all`} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-348">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-349">
          <h3 className="text-lg font-semibold text-gray-900" id="modal-title" data-id="element-350">
            {title}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-full p-1" data-id="element-351">
            <span className="sr-only" data-id="element-352">Close</span>
            <XIcon className="h-5 w-5" data-id="element-353" />
          </button>
        </div>

        <div className="px-6 py-4" data-id="element-354">{children}</div>
      </div>
    </div>;
}